import './app';



// WEBPACK FOOTER //
// ./src/index.js